import axios from 'axios';

// Interceptor per aggiungere automaticamente gli header tenant
axios.interceptors.request.use(
  (config) => {
    // SOLO se siamo nella pagina tenant (/tenant) aggiungiamo gli header tenant
    const isTenantPage = window.location.pathname.startsWith('/tenant');
    
    if (isTenantPage) {
      // Usa token tenant
      const token = localStorage.getItem('tenant_token');
      if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
      }
      
      // Aggiungi header tenant DB
      const tenantList = localStorage.getItem('tenant_list');
      if (tenantList) {
        try {
          const tenants = JSON.parse(tenantList);
          const defaultTenant = tenants.find(t => t.is_default) || tenants[0];
          if (defaultTenant && defaultTenant.database_name) {
            // Rimuovi il prefisso 'tenant_' per compatibilità con le collection prefissate
            config.headers['X-Tenant-DB'] = defaultTenant.database_name.replace('tenant_', '');
          }
        } catch (e) {
          console.error('Error parsing tenant list:', e);
        }
      }
    } else {
      // Contesto app principale - NON aggiungere MAI header X-Tenant-DB
      // e usa token normale
      if (!config.headers['Authorization']) {
        const token = localStorage.getItem('token');
        if (token) {
          config.headers['Authorization'] = `Bearer ${token}`;
        }
      }
      // IMPORTANTE: Rimuovi esplicitamente l'header X-Tenant-DB se presente
      if (config.headers['X-Tenant-DB']) {
        delete config.headers['X-Tenant-DB'];
      }
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default axios;
